import loadable from '@loadable/component';

// 懒加载组件
const HospitalInventoryQuery = loadable(() => import('./hospitalInventoryQuery/HospitalInventoryQuery'));

export const subRoutes = [
  {
    // M834251015 供应商：医院库存查询
    path: '/HospitalInventoryQuery',
    component: HospitalInventoryQuery
  }
];
